import { useState } from 'react';
import React from 'react';

import { Box } from '@rbilabs/universal-components';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { CustomEventNames } from 'state/amplitude';

import { MenuReorderCard } from './menu-reorder-card';
import { MenuReorderDetailsDrawer } from './menu-reorder-details-drawer';
import { useLastOrderAvailableToReorder } from './use-last-order-available-to-reorder';

export const MenuReorderWidget = () => {
  const openDetailEventMessage = CustomEventNames.LAST_ORDER_DETAILS;
  const lastOrder = useLastOrderAvailableToReorder();
  const [isDetailsDrawerOpen, setIsDetailsDrawerOpen] = useState<boolean>(false);
  const toggleDetailsDrawer = () => setIsDetailsDrawerOpen(!isDetailsDrawerOpen);

  if (!lastOrder) {
    return null;
  }

  return (
    <CenteredRowContainer>
      {isDetailsDrawerOpen ? (
        <MenuReorderDetailsDrawer
          order={lastOrder}
          showDrawer={isDetailsDrawerOpen}
          toggleDetailsDrawer={toggleDetailsDrawer}
          openDetailEventMessage={openDetailEventMessage}
        />
      ) : (
        <Box padding="$4">
          <MenuReorderCard
            order={lastOrder}
            toggleDetailsDrawer={toggleDetailsDrawer}
            drawerIsOpen={isDetailsDrawerOpen}
          />
        </Box>
      )}
    </CenteredRowContainer>
  );
};
